import { graphql, useStaticQuery } from "gatsby";
import * as React from "react";
import Helmet from "react-helmet";

import {
  address,
  contact,
  defaultDescription,
  legalName,
  name,
  logo,
  socialLinks,
  url,
} from "../../data/config";

const HomeMarkupSchema: React.FC = () => {
  const data = useStaticQuery(
    graphql`
      query RatesHomeSchemaQuery {
        allGooglePlacesPlace {
          nodes {
            user_ratings_total
            rating
          }
        }
      }
    `
  );
  const markup = `{ 
    "@context": "https://schema.org",
    "@type": "Physiotherapy",
    "name": "${name}",
    "alternateName": "Obelion Fisioterapeutas",
    "url": "${url}",
    "logo": "${logo}",
    "contactPoint": {
      "@type": "ContactPoint",
      "email": "${contact.email}",
      "telephone": "${contact.phone}",
      "contactType": "customer service",
      "areaServed": "ES",
      "availableLanguage": "ES"
    },
    "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "${data.allGooglePlacesPlace.nodes[0].rating}",
        "bestRating": "5",
        "worstRating": "1",
        "ratingCount": "${data.allGooglePlacesPlace.nodes[0].user_ratings_total}"
      },
    "sameAs": [
      "${socialLinks.facebook}",
      "${socialLinks.twitter}",
      "${socialLinks.instagram}"
    ]
    }
  }`;
  const professionalServiceMarkup = `
{
 "@context": "https://schema.org",
  "@type": "Physiotherapy",
  "name": "${legalName}",
  "description": "${defaultDescription}",
  "image": "${logo}",
  "@id": "${url}",
  "url": "${url}",
  "telephone": "${contact.phone}",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "${address.streetAddress}",
    "addressLocality": "${address.city}",
    "postalCode": "${address.zipCode}",
    "addressCountry": "ES"
  },
  "geo": {
      "@type": "GeoCoordinates",
      "latitude": "41.64387",
      "longitude": "-0.881179"
    },
  "openingHoursSpecification": {
    "@type": "OpeningHoursSpecification",
    "dayOfWeek": [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday"
    ],
    "opens": "11:00",
    "closes": "20:30"
  },
  "department": [{
    "@type": "PhysicalTherapy",
    "name": "Ecografía fisioterapia en Zaragoza",
    "url": "${url}ecografia/",
    "description": "Servicio de ecografía diagnóstica y terapéutica para fisioterapia."
  },{
    "@type": "PhysicalTherapy",
    "name": "Técnica de punción seca en Zaragoza",
    "url": "${url}puncion-seca/",
    "description": "Tratamiento de puntos gatillo miofasciales mediante punción seca."
  },{
    "@type": "PhysicalTherapy",
    "name": "Fisioterapia invasiva ecoguiada con EPI en Zaragoza",
    "url": "${url}epi/",
    "description": "Electrólisis Percutánea Intratisular (EPI) ecoguiada para tendinopatías y lesiones musculares."
  },{
    "@type": "PhysicalTherapy",
    "name": "Terapia manual avanzada",
    "url": "${url}terapia-manual-avanzada/",
    "description": "Aplicación de técnicas manuales avanzadas para el tratamiento de disfunciones neuromusculoesqueléticas."
  },{  
    "@type": "PhysicalTherapy",
    "name": "Tratamiento INDIBA radiofrecuencia en Zaragoza",
    "url": "${url}indiba/",
    "description": "Terapia de radiofrecuencia INDIBA para acelerar la recuperación de tejidos."
  },{
    "@type": "PhysicalTherapy",
    "name": "Fisioterapia Activa con control motor en Zaragoza",
    "url": "${url}ejercicios-control-motor/",
    "description": "Programas de ejercicio terapéutico enfocados en el control motor."
  },{
    "@type": "Service",
    "name": "Personal training Zaragoza",
    "url": "${url}personal-training/",
    "description": "Entrenamiento personal individualizado adaptado a tus objetivos."
  },{  
    "@type": "Service",
    "name": "Pilates en Zaragoza",
    "url": "${url}pilates/",
    "description": "Clases de Pilates suelo y máquina para mejorar fuerza, flexibilidad y control corporal."    
  },{
    "@type": "Service",
    "name": "Entrenamientos grupales",
    "url": "${url}training/",
    "description": "Sesiones de entrenamiento funcional y otras disciplinas en grupos reducidos."
  }]

}
  	`;
  return (
    <Helmet>
      <script type="application/ld+json">{markup}</script>
      <script type="application/ld+json">{professionalServiceMarkup}</script>
    </Helmet>
  );
};

export default HomeMarkupSchema;
